import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Sampoorna</h3>
            <p>Sampoorna is a wellness, healing and spiritual centre created to help individuals reconnect with themselves—physically, emotionally, mentally and spiritually.</p>
            <p>Rooted in Vedic traditions, Ayurveda, spirituality and holistic wellness, Sampoorna offers a space to pause, reflect, heal and realign.</p>
          </div>
          <div className="footer-section">
            <h3>Work Hours</h3>
            <p><strong>Monday - Saturday</strong><br />09:00am - 7:00 pm</p>
            <p><strong>And all the Sundays</strong><br />Will be Holidays</p>
          </div>
          <div className="footer-section">
            <h3>Contact Us</h3>
            <p><strong>Phone:</strong> <a href="tel:+918130885755">+91-8130885755</a></p>
            <p><strong>Email:</strong> <a href="mailto:anchal.rana@globalsampoorna.com">anchal.rana@globalsampoorna.com</a></p>
            <p><strong>Address:</strong> C707, Siksha Bharti school road, near ramphal Chowk, Sec -7 Dwarka, Delhi 110077</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/plans">Our Plans</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <ul className="footer-links">
              <li><a href="/return-policy">Return Policy</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms-conditions">Terms and Conditions</a></li>
              <li><a href="/shipping-policy">Shipping and Delivery Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>SAMPOORNA © 2024. Technical partner: Drift developers.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
